import { demoDashboard } from "./demo-data";
import type { DashboardPayload } from "./types";

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, "");
const forceDemo = import.meta.env.VITE_USE_DEMO_DATA === "true";

export async function getDashboard(signal?: AbortSignal): Promise<{
  data: DashboardPayload;
  isDemo: boolean;
}> {
  if (!apiBaseUrl || forceDemo) {
    return { data: demoDashboard, isDemo: true };
  }

  const response = await fetch(`${apiBaseUrl}/dashboard?days=90`, {
    signal,
    headers: { accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`Dashboard API returned ${response.status}`);
  }
  return { data: (await response.json()) as DashboardPayload, isDemo: false };
}
